module.exports = __webpack_public_path__ + "static/media/planet.ba6e9302.svg";